module.exports = __webpack_public_path__ + "static/img/corenrImgTwo.4b785bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/corenrImgTwo.png
// module id = O0IW
// module chunks = 1